import { Component, computed, inject, signal } from '@angular/core';
import { ActivatedRoute, Data, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { LeafletGroupComponent } from '@components/leaflet/group/group.component';
import { environment } from '@environment';
import { PlanktonEvent, createPointGeometry } from '@models';
import { PlanktonEventTitlePipe } from '@pipes';
import { AuthService, TitleService } from '@services';
import { PlanktonPropertyListComponent } from '../../propertylist/propertylist.component';
import geojson from 'geojson';

@Component({
  selector: 'app-plankton-event-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  imports: [
    CommonModule,
    LeafletGroupComponent,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatMenuModule,
    PlanktonPropertyListComponent,
    RouterModule,
  ],
})
export class PlanktonEventItemComponent {
  authService = inject(AuthService);
  titleService = inject(TitleService);
  getEventTitle = new PlanktonEventTitlePipe().transform;

  kinkoHost = environment.kinkoHost;

  route = inject(ActivatedRoute);

  event = signal<PlanktonEvent>(this.route.snapshot.data['event']);
  title = computed(() => this.getEventTitle(this.event()));

  constructor() {
    this.route.data.subscribe((data: Data) => {
      this.event.set(data['event']);
      this.titleService.setTitle(this.title());
    });
  }

  geometry(): geojson.FeatureCollection {
    return createPointGeometry(this.event());
  }
}
